import React from "react";
import "./App.css";
import { Globe } from "lucide-react";
import Header from "./components/layout/Header";
import HeroSection from "./components/sections/HeroSection";
import WorkSection from "./components/sections/WorkSection";
import AboutSection from "./components/sections/AboutSection";
import Footer from "./components/sections/Footer";

const PoweredBadge = () => (
  <a
    href="https://web-techservices.com"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-4 right-4 z-[10000] inline-flex items-center gap-2 bg-black border border-white/10 rounded-full px-3.5 py-2 no-underline hover:border-white/20 transition-colors duration-300"
    style={{ fontFamily: "'Open Sans', sans-serif" }}
  >
    <Globe className="w-4 h-4 text-white" strokeWidth={1.5} />
    <span className="text-white text-[11px] font-semibold tracking-wide whitespace-nowrap">
      Powered by Web-Techservices AI
    </span>
  </a>
);

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <WorkSection />
        <AboutSection />
        <Footer />
      </main>
      <PoweredBadge />
    </div>
  );
}

export default App;
